

const SIDENAV_ACTIVE = "#1565C8";
const SIDENAV_TEXT = "rgba(255, 255, 255, 0.88)";
const SIDENAV_ICON_INACTIVE_BG = "rgba(255, 255, 255, 0.12)";
const SIDENAV_ICON_ACTIVE_BG = "rgba(255, 255, 255, 0.2)";
const SIDENAV_HOVER = "rgba(255, 255, 255, 0.08)";

function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, functions } = theme;
  const { active, whiteSidenav } = ownerState;

  const { white, transparent, primary } = palette;
  const { pxToRem } = functions;
  const activeBg = whiteSidenav ? primary.main : SIDENAV_ACTIVE;

  return {
    background: active ? activeBg : transparent.main,
    color: active ? white.main : whiteSidenav ? palette.dark.main : white.main,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    minHeight: pxToRem(44),
    padding: `${pxToRem(6)} ${pxToRem(12)}`,
    margin: `${pxToRem(2)} 0`,
    borderRadius: pxToRem(999),
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
    boxShadow: "none",
    textDecoration: "none",

    [breakpoints.up("xl")]: {
      transition: transitions.create(["background-color", "color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: active ? activeBg : whiteSidenav ? "rgba(21, 101, 192, 0.08)" : SIDENAV_HOVER,
      boxShadow: "none",
    },
  };
}

function collapseIconBox(theme, ownerState) {
  const { palette, transitions, functions } = theme;
  const { active, whiteSidenav } = ownerState;

  const { white, primary } = palette;
  const { pxToRem } = functions;

  return {
    minWidth: pxToRem(36),
    width: pxToRem(36),
    height: pxToRem(36),
    flexShrink: 0,
    color: active ? white.main : whiteSidenav ? primary.main : white.main,
    backgroundColor: active
      ? SIDENAV_ICON_ACTIVE_BG
      : whiteSidenav
        ? white.main
        : SIDENAV_ICON_INACTIVE_BG,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    padding: 0,
    marginRight: pxToRem(10),
    transition: transitions.create("background-color", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& .MuiIcon-root": {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: `${pxToRem(20)} !important`,
      lineHeight: 1,
      width: pxToRem(20),
      height: pxToRem(20),
      transform: `translateY(${pxToRem(1)})`,
    },

    "& svg": {
      display: "block",
      width: pxToRem(20),
      height: pxToRem(20),
      fontSize: pxToRem(20),
    },

    "& svg, svg g": {
      color: `${active ? white.main : whiteSidenav ? primary.main : white.main} !important`,
    },

    "&:hover": {
      backgroundColor: active
        ? SIDENAV_ICON_ACTIVE_BG
        : whiteSidenav
          ? white.main
          : "rgba(255, 255, 255, 0.16)",
    },
  };
}

const collapseIcon = ({ palette: { white, primary } }, ownerState) => {
  const { active, whiteSidenav } = ownerState;
  return {
    color: `${active ? white.main : whiteSidenav ? primary.main : white.main} !important`,
  };
};

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions, palette } = theme;
  const { miniSidenav, transparentSidenav, active, whiteSidenav } = ownerState;

  const { size, fontWeightMedium, fontWeightRegular } = typography;
  const { pxToRem } = functions;
  const { white, dark } = palette;

  return {
    flex: 1,
    margin: 0,
    textAlign: "left",

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      transition: transitions.create(["opacity", "max-width"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span, & .MuiListItemText-primary, & .MuiTypography-root": {
      fontWeight: active ? fontWeightMedium : fontWeightRegular,
      fontSize: size.sm,
      lineHeight: 1.35,
      marginTop: 0,
      color: `${active ? white.main : whiteSidenav ? dark.main : SIDENAV_TEXT} !important`,
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
